import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CopyIdSnackbarComponent } from '../shared-components/copy-id-snackbar/copy-id-snackbar.component';

const UUID_REGEX =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private snackbar = inject(MatSnackBar);
  private router = inject(Router);

  private static isString(s: any): boolean {
    return typeof s === 'string' || s instanceof String;
  }

  public showError(error: any) {
    let errorResponse;
    if (MessageService.isString(error.error)) {
      errorResponse = JSON.parse(error.error);
    } else {
      errorResponse = error.error;
    }

    let message: string = errorResponse.detail
      ? errorResponse.detail
      : errorResponse.title;
    if (errorResponse.violations) {
      const violation = errorResponse.violations[0];
      message = violation.field + ' ' + violation.message;
    }
    const uuidMatch = message.match(UUID_REGEX);
    if (uuidMatch) {
      this.snackbar.openFromComponent(CopyIdSnackbarComponent, {
        data: { message, id: uuidMatch[0] },
        duration: 8000,
      });
      return;
    }

    let action;
    if (
      message.toLowerCase().includes('purchase') ||
      message.toLowerCase().includes('upgrade')
    ) {
      action = 'Purchase';
    }
    if (message.toLowerCase().includes('server')) {
      action = 'Get Server';
    }
    const ref = this.snackbar.open(message, action, {
      duration: 3000,
    });

    if (action) {
      ref.onAction().subscribe(() => {
        if (action === 'Purchase') {
          this.router.navigate(['/payment']);
        } else if (action === 'Get Server') {
          this.router.navigate(['/server']);
        }
      });
    }
  }

  showMessage(message: string, infiniteDuration = false) {
    const uuidMatch = message.match(UUID_REGEX);
    if (uuidMatch) {
      const ref = this.snackbar.openFromComponent(CopyIdSnackbarComponent, {
        data: { message, id: uuidMatch[0] },
        duration: infiniteDuration ? 0 : 8000,
      });
      return ref.afterDismissed();
    }

    let action;
    if (
      message.toLowerCase().includes('purchase') ||
      message.toLowerCase().includes('upgrade')
    ) {
      action = 'Purchase';
    }
    if (message.toLowerCase().includes('server')) {
      action = 'Get Server';
    }

    const ref = this.snackbar.open(message, action, {
      duration: infiniteDuration ? 0 : 5000,
    });

    if (action) {
      ref.onAction().subscribe(() => {
        if (action === 'Purchase') {
          this.router.navigate(['/payment']);
        } else if (action === 'Get Server') {
          this.router.navigate(['/server']);
        }
      });
    }

    return ref.afterDismissed();
  }

  showMessageWithAction(
    message: string,
    action: string,
    actionCallback: () => void,
  ) {
    const ref = this.snackbar.open(message, action, {
      duration: 4000,
    });

    ref.onAction().subscribe(actionCallback);

    return ref.afterDismissed();
  }
}
